import App from './App.svelte';

const app = new App({
	target: document.body,
	props: {
		propsName: 'Urffan Fadillah',
		propsProfile: 'https://dummyimage.com/400x400/000/fff'		
	}
});

export default app;